"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useImageSize = exports.getImageSize = exports.Error = void 0;
var constants_1 = require("./lib/constants");
Object.defineProperty(exports, "Error", { enumerable: true, get: function () { return constants_1.ErrorMessage; } });
var getImageSize_1 = require("./lib/getImageSize");
Object.defineProperty(exports, "getImageSize", { enumerable: true, get: function () { return getImageSize_1.getImageSize; } });
var useImageSize_1 = require("./lib/useImageSize");
Object.defineProperty(exports, "useImageSize", { enumerable: true, get: function () { return useImageSize_1.useImageSize; } });
